const React = require('react');
const upperFirst = require('mn-utils/upperFirst');
const formatTime = require('mn-utils/formatTime');
const formatNum = require('mn-utils/formatNum');

const toEllipsisMiddle = require('../../../../../../utils/toEllipsisMiddle');
const formatNumCurrency = require('../../../../../../utils/formatNumCurrency');
const parseCryptoToken = require('../../../../../../utils/parseCryptoToken');
const isOrderExpired = require('../../../../../../utils/isOrderExpired');

const paymentTypes = require('../../../../../../constants/paymentTypes');

const Tooltip = require('../../../../../dumb/Tooltip/B');

module.exports = (props) => {
  const fee = props.data.lunu_fee_amount || {};
  const data = props.data.quote || {};

  const {
    state: status,
    payment_method,
    customer_email,
    cc_code,
    crypto_amount,
    fiat_code,
    fiat_amount,
    merchant_trx_id,
    created_at,
  } = data;

  const paymentMethodName = paymentTypes[payment_method];

  return (
    <div
      className={`w layoutRow fhaS fvaC h70 rlv lh fw7 f12 c2 tc lts0em
           ph20 (ph10|w1/6)>1 bgF6F6F6.even` + (props.index % 2 === 1 ? ' even' : '')}
    >
      <div className="tl pl25@d2 lh130%">
        <div>
          {paymentMethodName
            ? paymentMethodName
            : upperFirst(payment_method || '').replace('_', ' ')
          }
        </div>
         <Tooltip className="fhaS*2 f12 lh lts0em c717275 fw4 mt3">
          {customer_email}
         </Tooltip>
      </div>
      <div>
        {merchant_trx_id ? (
          <Tooltip title={merchant_trx_id}>
            {toEllipsisMiddle(merchant_trx_id, 15)}
          </Tooltip>
        ) : '-'}
      </div>
      <div>
        {created_at ? (
          <Tooltip title={formatTime.getRFC3339(created_at)}>
            <div>
              {formatTime(created_at, '{dd} {mmm}, {yyyy}')}
            </div>
            <div className="c717275 fw4 mt3">
              {formatTime(created_at, '{hh}:{MM}:{ss} {TT}')}
            </div>
          </Tooltip>
        ) : null}
      </div>
      <div>
        <Tooltip
          className="f12 lh lts0em c2"
          title={fiat_amount}
        >
          {formatNumCurrency(fiat_amount)} {fiat_code}
        </Tooltip>
        {
          crypto_amount ? (
            <Tooltip
              className="f12 lh lts0em c717275 fw4 mt3"
              title={crypto_amount}
            >
              {formatNum(crypto_amount, 8)} {parseCryptoToken(cc_code)[1]}
            </Tooltip>
          ) : null
        }
      </div>
      <div>
        <Tooltip
          className="f12 lh lts0em c2"
          title={fee}
        >
          {formatNumCurrency(fee)} {fiat_code}
        </Tooltip>
      </div>
      <div>
        <div
          className={`f12 lh lts0em c0 cFFBF43.created cFFBF43.confirmed c2CE889.completed
                c9C8FFF.requested c717275.expired cEE4F4F.cancelled cEE4F4F.failed ` + status}
        >
          {upperFirst(status)}
        </div>
      </div>
    </div>
  );
};
